module.exports = __webpack_public_path__ + "img/zytlogo.d4c12bf8.png";